<script>
    export let bgColor = 'bg-slate-400';
    export let imgSrc = '';
    export let imgSide = 'left';
    export let title = 'Card Title';
    export let text = 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.';
    export let subText = '';
</script>


<div class="flex justify-center my-5">
    <div class="flex flex-col md:flex-row md:max-w-3xl rounded-lg {bgColor} bg-opacity-70 shadow-lg">
        {#if (imgSide != 'right' && imgSide != 'r') && imgSrc != ''}
            <img class=" w-full h-96 md:h-auto object-cover md:w-48 rounded-t-lg md:rounded-none md:rounded-l-lg" src="{imgSrc}" alt="" />
        {/if}
        <div class="p-6 flex flex-col justify-start">
            <h5 class="text-slate-900 text-xl font-medium mb-2">{title}</h5>
            <p class="text-slate-700 text-base mb-4">{text}</p>
            {#if subText != ''}
                <p class="text-slate-600 text-xs">{subText}</p>
            {/if}
        </div>
        {#if (imgSide == 'right' || imgSide == 'r') && imgSrc != ''}
            <img class=" w-full h-96 md:h-auto object-cover md:w-48 rounded-b-lg md:rounded-none md:rounded-r-lg" src="{imgSrc}" alt="" />
        {/if}
        
    </div>
</div>
